import moment from "moment-timezone"

const DiscountsForm = {
  initialize() {
    this.initializeTimepicker()
    this.updateKind()
    this.updateMinimum()
    $("#discount_minimum_group_size").on("change", () => {
      return this.updateMinimum()
    })
    $(".select-kind-js").on("change", () => {
      return this.updateKind()
    })
    this.updateAmountKind()
    $(".select-amount-kind-js").on("change", () => {
      return this.updateAmountKind()
    })
    return $("#expiry-checkbox").on("change", () => {
      return this.updateExpires()
    })
  },

  updateMinimum() {
    let minN
    const min = $("#discount_minimum_group_size").val()
    if (min === "") {
      minN = 1
    } else {
      minN = parseInt(min)
    }
    let text = "Apply to everyone after the <strong>"
    text += this.getOrdinal(minN)
    text += "</strong> attendee"
    return $("label[for=discount_additional_only_true]").html(text)
  },

  getOrdinal(n) {
    const s = ["th", "st", "nd", "rd"]
    const v = n % 100
    return n + (s[(v - 20) % 10] || s[v] || s[0])
  },

  updateKind() {
    const target = $(".select-kind-js")
    switch (target.val()) {
      case "early_bird":
        return this.makeEarlyBird()
      case "group":
        return this.makeGroup()
      case "code":
        return this.makeCode()
      default:
        return this.resetKinds()
    }
  },

  updateAmountKind() {
    const target = $(".select-amount-kind-js")
    switch (target.val()) {
      case "percent":
        return this.makePercent()
      case "flat":
        return this.makeFlat()
      default:
        return this.resetAmounts()
    }
  },

  updateExpires() {
    if ($("#expiry-checkbox").is(":checked")) {
      $(".expires-block-js").removeClass("hide")
      if (App.currentOrganization.twentyFourHourTime) {
        $(".expires-at-time-js").val("00:00")
      } else {
        $(".expires-at-time-js").val("12:00am")
      }
      $(".expires-at-date-default").attr("name", "")
    } else {
      $(".expires-block-js").addClass("hide")
      $(".expires-at-date-default").attr("name", "discount[expires_at_date]")
      return $(".expires-at-time-js").val("")
    }
  },

  initializeTimepicker() {
    return $("#discount_expires_at_time").timepicker(App.currentOrganization.timepickerDefaults())
  },

  makePercent() {
    $(".amount-cents-js").addClass("hide")
    $(".amount-percent-js").removeClass("hide")
  },

  makeFlat() {
    $(".amount-cents-js").removeClass("hide")
    $(".amount-percent-js").addClass("hide")
    $(".apply-to-add-ons-js .checkbox").prop("checked", false)
  },

  makeEarlyBird() {
    $(".code-js").addClass("hide")
    $(".minimum-group-size-js").addClass("hide")
    $(".type-code-js, .type-group-js").val("")
    $("#expiry-checkbox")
      .prop("checked", true)
      .trigger("change")
    $(".expiry-checkbox-wrapper-js .checkbox").attr("disabled", true)
  },

  makeGroup() {
    $(".code-js").addClass("hide")
    $(".type-code-js").val("")
    $(".minimum-group-size-js").removeClass("hide")
    $(".expiry-checkbox-wrapper-js .checkbox").attr("disabled", false)
  },

  makeCode() {
    $(".code-js").removeClass("hide")
    $(".type-group-js").val("")
    $(".minimum-group-size-js").addClass("hide")
    $(".expiry-checkbox-wrapper-js .checkbox").attr("disabled", false)
  },

  resetAmounts() {
    $(".amount-cents-js").addClass("hide")
    $(".amount-percent-js").addClass("hide")
    return $(".apply-to-add-ons-js .checkbox").attr("disabled", false)
  },

  resetKinds() {
    $(".expires-block-js, .code-js, .minimum-group-size-js").addClass("hide")
    $(".type-code-js, .type-group-js").val("")
    $(".expiry-checkbox-wrapper-js .checkbox").prop("checked", false)
    $(".expiry-checkbox-wrapper-js .checkbox").attr("disabled", true)
  }
}

export default DiscountsForm
